import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal } from 'antd'

const AssessmentDetail = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [AssessmentDetail, setAssessmentDetail] = useState({})

  const getAssessmentDetail = () => {
    axios.post('/p/assessment/record/detail/get', {
      merchant_oid: merchantOid,
      record_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setAssessmentDetail(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAssessmentDetail()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, props.data.oid])

  const handleCancel = () => {
    props.isCancel()
  }

  return (
    <Modal 
      title="测评详情"
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onCancel={handleCancel}
      footer={false}>
      
      <div className='public-datail-container'>
        <div className='public-datail-item'>
          <div className='public-datail-label'>测评时间</div>
          <div className='public-datail-content'>{AssessmentDetail.create_time}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>姓名</div>
          <div className='public-datail-content'>{AssessmentDetail.name || '匿名用户'}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>身份证号</div>
          <div className='public-datail-content'>{AssessmentDetail.id_number || '-'}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>手机号</div>
          <div className='public-datail-content'>{AssessmentDetail.phone || '-'}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>学院</div>
          <div className='public-datail-content'>{AssessmentDetail.college || '-'}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>专业</div>
          <div className='public-datail-content'>{AssessmentDetail.major || '-'}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>测评项目</div>
          <div className='public-datail-content'>{AssessmentDetail.assessment_name}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>测试结果</div>
          <div className='public-datail-content'>{AssessmentDetail.result}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>结果解读</div>
          <div className='public-datail-content'>{AssessmentDetail.interpretation}</div>
        </div>
      </div>
    </Modal>
  )
}

export default AssessmentDetail
